import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResourceResponse, ResourceStoreContext } from '../../../common/types.tsx';
import type { ResourceStoreData } from '../../common/types.tsx';

import type { ResourceSliceIdentifier, State } from './types.tsx';
import { getDefaultStateSlice } from './utils/get-default-state-slice/index.tsx';

export const getSliceForResourceOld = (
	state: { data: ResourceStoreData; context?: ResourceStoreContext },
	props: ResourceSliceIdentifier,
): RouteResourceResponse => {
	const { type, key } = props;
	const slice = state.data[type] && (state.data[type][key] as RouteResourceResponse);

	return slice ? { ...slice } : getDefaultStateSlice();
};

const defaultStateSlice = getDefaultStateSlice();

export const getSliceForResourceNew = (
	state: { data: ResourceStoreData; context?: ResourceStoreContext },
	props: ResourceSliceIdentifier,
): RouteResourceResponse => {
	const { type, key } = props;
	const slice = state.data[type] && (state.data[type][key] as RouteResourceResponse);

	// The return of this needs to be stable object references - no cloning/spreading or new objects
	// otherwise it will cause re-renders in components that use this selector
	return slice || defaultStateSlice;
};

export const getSliceForResource = functionWithCondition(
	() => fg('jfp-magma-concurrent-resource-router-stability'),
	getSliceForResourceNew,
	getSliceForResourceOld,
);

export const getResourceStoreContext = (state: State): ResourceStoreContext => state.context;
